import './Adminsignup.css';
import {
    Button,
    Container,
    Group,
    Image,
    Paper,
    PasswordInput,
    Stack,
    Text,
    TextInput, ThemeIcon
} from '@mantine/core';
import Boompaylogo from '../Assets/Boompaylogo.png';
import { IconMail, IconPhoneCall } from '@tabler/icons-react';
import { useState } from 'react';
import { message } from 'antd';
import { jwtDecode } from 'jwt-decode';
import { useAuthContext } from '../Hooks/UseAuthContext';




const Adminsignup = (PaperProps) => {
   // const [type, toggle] = useToggle(['login', 'register']);
    const { dispatch } = useAuthContext();
    const [signup, setsignup] = useState({
        Authorized_Person_Name: '',
        Authorized_Person_Mobile_Number: '',
        Company_Email: '',
        Company_Name: '',
        Profile_Password: ''
    })
    const [loading, setloading] = useState(false);


    const handelChange = (e) => {
        const { name, value } = e.target;
        setsignup({ ...signup, [name]: value });
    }

    const saveToken = (token) => {
        const decodedToken = jwtDecode(token); // Use jwt-decode library
        const expiryTime = decodedToken.exp * 1000; // Convert expiry time to milliseconds
        localStorage.setItem('user', token);
        localStorage.setItem('expiryTime', expiryTime);
    };

    const handleLogin = async () => {
        const { Company_Email, Profile_Password } = signup;
        if (!Company_Email || !Profile_Password) {
            message.error('Please fill in all the fields');
            return;
        }
        setloading(true);
        try {
            const response = await fetch('https://api.boompay.in/login-admin', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(signup)
            });
            const data = await response.json();
            //console.log(data);
            if (response.status === 200) {
                message.success('Login successfully.');
                setloading(false);
                setsignup({
                    Company_Email: '',
                    Profile_Password: ''
                })
                saveToken(data.token);
                dispatch({ type: 'LOGIN', payload: data.token });
                window.location.href = '/admin'
            } else if (response.status === 400) {
                message.error(data.message);
                setloading(false);
            } else if (response.status === 403) {
                message.info(data.message);
                setloading(false);
            } else {
                message.error('Login failed. Please try again later.');
                setloading(false);
            }
        } catch (error) {
            console.error('Error:', error);
            message.error('An error occurred. Please try again later.');
            setloading(false);
        }
    }

    return (
        <>
            <Container size={'md'} mt={'xl'} p={'md'}>
                <Paper radius="md" p="lg" withBorder {...PaperProps}>
                    <Text size="lg" fw={500} c="bright">
                        Welcome (Admin) to login BOOM Pay!
                        <Group>
                            <Image src={Boompaylogo} alt='BOOM Pay' h={90} fit="contain" w="auto" />
                            <Paper withBorder p="md" radius="md">
                                <Group justify="apart">
                                    <div>
                                        <Text c="dimmed" tt="uppercase" fw={700} fz="xs" className="label">
                                            Email Support
                                        </Text>
                                        <Text fw={700} fz="xl">
                                            info@boompay.in
                                        </Text>
                                    </div>
                                    <ThemeIcon
                                        color="gray"
                                        variant="light"
                                        style={{
                                            color: 'var(--mantine-color-teal-6)',
                                        }}
                                        size={38}
                                        radius="md"
                                    >
                                        {/* <DiffIcon size={28} stroke={1.5} /> */}
                                        <IconMail size={28} stroke={1.5} />
                                    </ThemeIcon>
                                </Group>
                                {/* <Text c="dimmed" fz="sm" mt="md">
                                    <Text component="span" c={stat.diff > 0 ? 'teal' : 'red'} fw={700}>
                                        {stat.diff}%
                                    </Text>{' '}
                                    {stat.diff > 0 ? 'increase' : 'decrease'} compared to last month
                                </Text> */}

                            </Paper>
                            <Paper withBorder p="md" radius="md">
                                <Group justify="apart">
                                    <div>
                                        <Text c="dimmed" tt="uppercase" fw={700} fz="xs" className="label">
                                            Call Support
                                        </Text>
                                        <Text fw={700} fz="xl">
                                            +91 770-183-6668
                                        </Text>
                                    </div>
                                    <ThemeIcon
                                        color="gray"
                                        variant="light"
                                        style={{
                                            color: 'var(--mantine-color-teal-6)',
                                        }}
                                        size={38}
                                        radius="md"
                                    >
                                        {/* <DiffIcon size={28} stroke={1.5} /> */}
                                        <IconPhoneCall size={28} stroke={1.5} />
                                    </ThemeIcon>
                                </Group>
                                {/* <Text c="dimmed" fz="sm" mt="md">
                                    <Text component="span" c={stat.diff > 0 ? 'teal' : 'red'} fw={700}>
                                        {stat.diff}%
                                    </Text>{' '}
                                    {stat.diff > 0 ? 'increase' : 'decrease'} compared to last month
                                </Text> */}

                            </Paper>
                        </Group>
                    </Text>

                    {/* <Group grow mb="md" mt="md">
                    <GoogleButton radius="xl">Google</GoogleButton>
                    <TwitterButton radius="xl">Twitter</TwitterButton>
                </Group> */}

                    {/* <Divider
                        label="Or continue with email"
                        labelPosition="center"
                        my="lg"
                        styles={{ label: { color: 'var(--mantine-color-bright)', opacity: 0.85 } }}
                    /> */}

                    <Stack my="lg">

                        <>
                            <TextInput
                                required
                                label="Registered ID"
                                placeholder="hello@company.mail"
                                name="Company_Email"
                                value={signup.Company_Email}
                                onChange={handelChange}
                                radius="md"
                            />

                            <PasswordInput
                                required
                                label="Registered Password"
                                placeholder="Your password"
                                name="Profile_Password"
                                value={signup.Profile_Password}
                                onChange={handelChange}
                                radius="md"
                            />
                        </>
                    </Stack>

                    <Group justify="end" mt="xl">
                        {/* <Anchor
                            component="button"
                            type="button"
                            c="bright"
                            opacity={0.85}
                            onClick={() => toggle()}
                            size="xs"
                        >
                            {type === 'register'
                                ? 'Already have an account? Login'
                                : "Don't have an account? Register"}
                        </Anchor> */}
                        {
                            <Button radius="xl" onClick={handleLogin} loading={loading}>
                                Login
                            </Button>
                        }
                    </Group>
                </Paper>
            </Container>
        </>
    )
}

export default Adminsignup;